import { TOOLTIP_DEFINITIONS } from '../constants/tooltips';
import { useCubeFilter } from '../hooks';
import DimensionBreakdownChart from './DimensionBreakdownChart';

export interface WorkEventsBreakdownChartProps {
  dimensionSpec: { label: string; metric: string };
  sortByValue?: boolean;
}

// Tooltip mapping for dimension metrics
const TOOLTIP_MAPPING = {
  'WorkDoneByUser.workedArAgeGroup':
    TOOLTIP_DEFINITIONS.productivity_charts.work_events_breakdown_age,
  'WorkDoneByUser.claimResponseType':
    TOOLTIP_DEFINITIONS.productivity_charts.work_events_breakdown_responses,
  'WorkDoneByUser.expectedValueGroup':
    TOOLTIP_DEFINITIONS.productivity_charts.work_events_breakdown_expected,
} as const;
export default function WorkEventsBreakdownChart(
  props: WorkEventsBreakdownChartProps,
) {
  const { dimensionSpec, sortByValue } = props;
  let baseQuery = useCubeFilter('WorkDoneByUser', {
    useTimeDimensionsInsteadOfSegments: true,
  });
  baseQuery = {
    ...baseQuery,
    segments: [...baseQuery.segments, 'WorkDoneByUser.workedOnly'],
  };

  return (
    <DimensionBreakdownChart
      barSize={25}
      baseQuery={baseQuery}
      chartMetric='count'
      dimensionSpec={dimensionSpec}
      measureSpec={{
        count: { label: 'Work Events', metric: 'WorkDoneByUser.claimCount' },
      }}
      unitSpec={{ count: 'work' }}
      sortByValue={sortByValue}
      tooltip={
        TOOLTIP_MAPPING[dimensionSpec.metric as keyof typeof TOOLTIP_MAPPING]
      }
    />
  );
}
